import { io } from "socket.io-client";
import { emplacarAPI } from "./emplacar";
import { URL_BASE } from "./0_url_base";

const sanitizeUrl = (value) => (value ? value.replace(/\/+$/, "") : "");

const explicitSocketBase = sanitizeUrl(
  process.env.REACT_APP_SOCKET_BASE_URL || "",
);

const fallbackSocketBase = (() => {
  const cleaned = sanitizeUrl(URL_BASE);
  if (cleaned.toLowerCase().endsWith("/api")) {
    return cleaned.slice(0, -4);
  }
  return cleaned;
})();

const SOCKET_BASE_URL = explicitSocketBase || fallbackSocketBase;

const SOCKET_PATH =
  sanitizeUrl(process.env.REACT_APP_SOCKET_PATH) || "/socket.io";

const withToken = () => {
  const token = sessionStorage.getItem("token");
  return token ? { token } : undefined;
};

export const criarLoteEmplacamento = async (itens) => {
  const { data } = await emplacarAPI.post("/lotes", { itens });
  return data;
};

export const obterStatusLote = async (jobKey) => {
  const { data } = await emplacarAPI.get(`/lotes/${jobKey}`);
  return data;
};

export const conectarSocketLote = () => {
  const socket = io(SOCKET_BASE_URL, {
    path: SOCKET_PATH,
    withCredentials: true,
    transports: ["websocket"],
    auth: withToken(),
  });

  return socket;
};
